// @ts-nocheck
import React from 'react';
import { arrayMoveImmutable } from 'array-move';
import SortableList from './components/SortableList';

function TableColumnSortableComponent({ items, setItems, allColumns }) {
  const onSortEnd = (result) => {
    let ret = arrayMoveImmutable(items, result.oldIndex, result.newIndex);
    setItems(ret);
  };

  const handleColumnChange = (e, column) => {
    let newArr = [...items];
    let index = items.findIndex((x) => x.id === column.id);
    newArr[index] = { id: column.id, key: e.target.value };
    setItems(newArr);
  };

  const handleColumnDelete = (column) => {
    let newArr = [...items].filter((x) => x.id !== column.id);
    setItems(newArr);
  };

  return (
    <SortableList
      items={items}
      allColumns={allColumns}
      onSortEnd={onSortEnd}
      onColumnChange={handleColumnChange}
      onColumnDelete={handleColumnDelete}
    />
  );
}



export default TableColumnSortableComponent;
